import type { WebapiEndpointBuilder } from '@/api/webapi.ts';
import { closeCashRfs } from '@/store/cash/api/requestCashRfs.ts';

export type CancelCashRfsBody = {
  // useful to have a fixedCacheKey to remove the mutation result from the cache
  tileId: string;
  rfsId: string;
};

export type CancelCashRfsResponse = {};

export const cancelCashRfs = (builder: WebapiEndpointBuilder) => {
  return builder.mutation<CancelCashRfsResponse, CancelCashRfsBody>({
    query: (body) => {
      return {
        url: '/fxSpotFwd/rfs/cancel',
        method: 'POST',
        body: {
          rfsId: body.rfsId,
        },
      };
    },

    onQueryStarted({ tileId }, { dispatch }): Promise<void> | void {
      closeCashRfs(tileId, dispatch);
    },
  });
};
